import { render } from "./Prize.vue?vue&type=template&id=8c53862e&scoped=true&bindings={}"
import script from "./Prize.vue?vue&type=script&lang=ts"
export * from "./Prize.vue?vue&type=script&lang=ts"

import "./Prize.vue?vue&type=style&index=0&id=8c53862e&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-8c53862e"

export default script